var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12"}},[(_vm.messageInformation)?_c('BaseBlock',{attrs:{"title":_vm.titreInformation}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.messageInformation.message)}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }